<!-- Revised on 2025/10/16 by mnavarro -->
<template>
  <Button v-if="visible" size="xs" color="primary" :title="$t('key_button_add_brand')" variant="fill" @click="click()">
    <span>
      <i class="fa-solid fa-plus" aria-hidden="true"></i>
    </span>
  </Button>
</template>

<script>

  import Button from "./../../../generic_components/Button.vue";

  export default {
    name: "AddBrand",
    components: {
      Button
    },
    props: {
      enabled: {
        type: Boolean,
        default: true
      },
      visible: {
        type: Boolean,
        default: true
      },
    },
    emits: ['add-brand'],
    methods: {
      click() {
        this.$emit('add-brand');
      }
    }
  };

</script>